<template>
  <div class="pipefy">
    <div class="widget">
      <div class="widget-body">
        <div class="d-flex justify-content-between align-items-center">
          <div class="state">
            <h4>
              Pipefy CRM
              <small v-if="!activeIntegration">(Inativo)</small>
            </h4>
          </div>
          <div class="icon">
            <div class="d-flex align-items-center">
              <artificial-intelligence-icon add-margin-right="20px" />
              <div v-if="activeIntegration">
                <font
                  title="Configurações"
                  size="6"
                  color="black"
                  @click.prevent="toogleUpdateIntegration()">
                  <i class="ik ik-settings" />
                </font>
              </div>
              <div v-else>
                <font
                  title="Configurações"
                  size="6"
                  color="gray">
                  <i class="ik ik-settings" />
                </font>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-small mt-10 d-block">
            <toggle-button
              tag="pipefy"
              class="mb-1"
              :width="90"
              :height="30"
              :font-size="15"
              :value="activeIntegration"
              :sync="true"
              :labels="{checked: 'Ativo', unchecked: 'Ativar'}"
              @change="toogleIntegration" />
          </small>
          <font
            title="Tutorial"
            size="6"
            color="black"
            @click.prevent="openTutorial">
            <i class="ik ik-youtube" />
          </font>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="confirmDelete"
      ref="confirmDelete"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h4 class="modal-title">Você tem certeza que deseja remover a integração com Pipefy CRM?</h4>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">Não</button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="deleteIntegration">Sim</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="updateIntegration"
      ref="updateIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Configurar Pipefy CRM</h4>
            <div class="d-flex align-items-center">
              <artificial-intelligence-icon />
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
          <div class="modal-body">
            <ErrorAlert :error="error" />
            <p class="text-center">
              Para gerar/copiar seu Token de acesso pessoal
              <a
                class="link"
                href="https://app.pipefy.com/tokens"
                target="_blank">
                clique aqui
              </a>
            </p>
            <div class="form-group row">
              <label
                for="pipefyToken"
                class="col-sm-4 col-form-label">Token de acesso pessoal</label>
              <div class="col-sm-8">
                <input
                  id="pipefyToken"
                  type="text"
                  class="form-control"
                  v-model="token">
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-primary"
                :disabled="!configReady"
                @click.prevent="saveIntegration">{{ labelSubmit }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="successIntegration"
      ref="successIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração com a Pipefy CRM atualizada com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="uninstallIntegration"
      ref="uninstallIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração Pipefy removida com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <tutorial-video-modal
      ref="tutorialPipefy"
      title="Tutorial Pipefy"
      video-url="https://www.youtube.com/embed/cmxzlJyF-ys" />
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import PipefyWrapper from '@/services/pipefy-wrapper'
import ArtificialIntelligenceIcon from '@/components/Common/ArtificialIntelligenceIcon.vue'
import TutorialVideoModal from '@/components/Common/TutorialVideoModal.vue'

export default {
  name: 'IntegrationPipefy',
  components: {
    ArtificialIntelligenceIcon,
    TutorialVideoModal
  },
  data () {
    return {
      error: null,
      integration: null,
      configReady: false,
      token: null
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadIntegration()
    })
  },
  methods: {
    loadIntegration () {
      return loopback
        .get(`/integrations?filter[where][gateway]=pipefy`)
        .then(integrations => {
          this.integration = integrations.pop()
          if (this.integration && this.integration.metadata) {
            this.token = this.integration.metadata.token
          }
        })
        .catch(err => { this.$emit('onError', err) })
    },
    saveIntegration () {
      if (this.token && this.configReady) {
        this.error = null
        const integrationParams = {
          gateway: 'pipefy',
          webhook: true,
          webhookConstraint: {
            metadata: {
              api4comGateway: 'pipefy'
            }
          },
          metadata: {
            token: this.token,
            webhookUrl: `${process.env.API4COM_BASE_URL_API}${process.env.API4COM_VERSION_API}/integrations/webhook`,
            webhookVersion: 'v1.4',
            webhookTypes: ['channel-hangup']
          }
        }
        if (this.integration) integrationParams.id = this.integration.id
        loopback
          .patch('/integrations', integrationParams)
          .then(integration => {
            this.integration = integration
            $(this.$refs.updateIntegration).modal('hide')
            $(this.$refs.successIntegration).modal('show')
          })
          .catch(err => {
            this.error = err
            // TEL-2243: o `friendly` do interceptor ja resolve `details.messages` pelo
            // FIELD_MESSAGES, mantem em pt-BR o que o backend ja manda traduzido e nomeia
            // o campo quando nao ha texto proprio. Montar `lines` aqui devolvia o texto do
            // LoopBack em ingles e ainda sobrescrevia a traducao.
          })
      } else {
        this.error = {
          message: 'Token de acesso pessoal é obrigatório'
        }
      }
    },
    toogleIntegration (event) {
      if (event.value === true) {
        $(this.$refs.updateIntegration).modal('show')
      } else {
        $(this.$refs.confirmDelete).modal('show')
      }
    },
    toogleUpdateIntegration () {
      $(this.$refs.updateIntegration).modal('show')
    },
    deleteIntegration () {
      if (!this.integration) return
      loopback
        .delete(`/integrations/${this.integration.id}`)
        .then(_ => {
          this.integration = null
          this.token = null
          this.error = null
          this.configReady = false
          $(this.$refs.uninstallIntegration).modal('show')
        })
        .finally(_ => {
          $(this.$refs.confirmDelete).modal('hide')
        })
        .catch(err => { this.$emit('onError', err) })
    },
    openTutorial () {
      this.$refs.tutorialPipefy.open()
    },
    checkAccessToken (accessToken) {
      return PipefyWrapper.checkAccessToken(accessToken)
    },
    validAccessToken () {
      this.configReady = true
      this.error = null
    },
    invalidAccessToken () {
      this.configReady = false
      this.error = {
        message: 'Token de acesso pessoal inválido'
      }
    }
  },
  computed: {
    activeIntegration () {
      return this.integration && this.integration.gateway === 'pipefy'
    },
    labelSubmit () {
      return this.activeIntegration ? 'Salvar' : 'Ativar'
    }
  },
  watch: {
    token: function (token) {
      if (token) {
        this.checkAccessToken(token)
          .then(isValid => {
            if (isValid) this.validAccessToken()
            else this.invalidAccessToken()
          })
          .catch(_ => {
            this.invalidAccessToken()
          })
      } else {
        this.configReady = false
        this.error = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Integration/Pipefy.vue